import React from "react";

import styles from "./popular_facility.module.css";

export default function PopularFacilities({ property }) {
  const hotelPolicy = property?.hotelPolicy;

  const hotelInfo = hotelPolicy || {};

  const { internetAccessType, parkingType, isAdultsOnly, parkingIsPrivate } = hotelInfo;
  const isInternetAvailable = internetAccessType !== "none" && internetAccessType;
  const familyAllowed = isAdultsOnly === false;

  const isbusAvailable = parkingIsPrivate === false && parkingIsPrivate;
  const isParkingAvailable = parkingType !== "none" && parkingType;

  return (
    <>
      {/* <p className={styles.facilityTitle}> Most Common Facilities</p> */}

      {isInternetAvailable ? (
        <div className={styles.row}>
          <img src=".././wifi.png" alt="wifi" className={styles.iconImage} />
          <p className={styles.subheading}>Free Wifi</p>
        </div>
      ) : (
        <div className={styles.row}>
          <img src=".././no-signal.png" alt="no wifi" className={styles.iconImage} />
          <p className={styles.subheading}>No Wifi</p>
        </div>
      )}

      {isParkingAvailable ? (
        <div className={styles.row}>
          <img src=".././parking.png" alt="parking" className={styles.iconImage} />
          <p className={styles.subheading}>Free Parking </p>
        </div>
      ) : (
        <div className={styles.row}>
          <img src=".././no-parking.png" alt="no parking" className={styles.iconImage} />
          <p className={styles.subheading}>No Parking</p>
        </div>
      )}

      {familyAllowed ? (
        <div className={styles.row}>
          <img src=".././family.png" alt="parking" className={styles.iconImage} />
          <p className={styles.subheading}>Family rooms </p>
        </div>
      ) : (
        <div className={styles.row}>
          <img src=".././no-family.png" alt="no parking" className={styles.iconImage} />
          <p className={styles.subheading}>No Family rooms</p>
        </div>
      )}
    </>
  );
}
